module.exports = __webpack_public_path__ + "media/images/countryrect/la-eccec1d50dc93a660ec81397c1d06d37.svg";